import React, { useState } from 'react';

import { Tabs, Tab, Paper, Grid } from '@material-ui/core';

import { useStylesAuth } from '../../../styles/auth/style';
import { Fragment } from 'react';

export const GenericTab = ({ tabs = [], initTab = 0 }) => {
  const classes = useStylesAuth();

  const [activeTab, setActiveTab] = useState(initTab);

  return (
    <Paper elevation={2} className={classes.color}>
      <Tabs
        value={activeTab}
        onChange={(e, value) => setActiveTab(value)}
        style={{ backgroundColor: "#FFF" }}
        variant="fullWidth"
      >
        {tabs.filter(({filter}) => !filter).map(
          ({ isDisabled = false, label, icon, onClickTab = () => { } }, index) => (
            <Tab
              key={index}
              label={label}
              icon={icon ? icon : null}
              disabled={isDisabled}
              style={isDisabled ? { color: '#999999' } : null} 
              // style={activeTab === index ? { color: '#FFF', backgroundColor: "#68389F" } : { border: '1px solid #dadada' }}
              onClick={() => onClickTab(activeTab)}
            />
          )
        )}
      </Tabs>
      {tabs.filter(({filter}) => !filter).map(({ isDisabled = false, component }, index) => {
        if (isDisabled || activeTab !== index) {
          return null;
        }
        return (
          <Grid key={index} container justify='center' component={Paper} elevation={2} square>
            {component}
          </Grid>
        )
      })}
    </Paper>
  );
};

export const GTab = ({ tabs = [], initTab = 0 }) => {
  const [activeTab, setActiveTab] = useState(initTab);

  return (
    <>
      <Tabs
        value={activeTab}
        onChange={(e, value) => setActiveTab(value)}
        variant="fullWidth"
      >
        {tabs.filter(({filter}) => !filter).map(
          ({ isDisabled = false, label, icon, onClickTab = () => { } }, index) => (
            <Tab
              key={index}
              label={label}
              icon={icon ? icon : null}
              disabled={isDisabled}
              style={isDisabled ? { color: '#999999' } : null} 
              onClick={() => onClickTab(activeTab)}
            />
          )
        )}
      </Tabs>
      {tabs.filter(({filter}) => !filter).map(({ isDisabled = false, component }, index) => {
        if (isDisabled || activeTab !== index) {
          return null;
        }
        return (
          <Fragment key={index}>{component}</Fragment>
        )
      })}
    </>
  );
};